import { useState, useEffect, useRef } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useOutletContext } from "react-router-dom";
import { useJob } from "../../../../context/JobContext";
import config from "../../../../config/config";
import axios from "axios";
import {
  FaThumbsUp,
  FaThumbsDown,
  FaMapMarkerAlt,
  FaRedo,
  FaTimesCircle,
  FaFire,
} from "react-icons/fa";
import { LuListFilter } from "react-icons/lu";
import { useMediaQuery } from "react-responsive";
import { IoMdTime, IoIosCheckmarkCircleOutline } from "react-icons/io";
import { AiOutlineSchedule } from "react-icons/ai";

const DiscoverJobList = () => {
  const { workerUser } = useOutletContext();
  const { jobs, fetchAllJobs } = useJob();
  const [filteredJobs, setFilteredJobs] = useState([]);
  const [selectedJob, setSelectedJob] = useState(null);
  const [showDetails, setShowDetails] = useState(false);
  const [activeTab, setActiveTab] = useState("open");
  const [showModal, setShowModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [jobsPerPage] = useState(10);
  const [dislikeInfo, setDislikeInfo] = useState({ visible: false, text: "" });
  const [searchQuery, setSearchQuery] = useState("");
  const [filterCriteria, setFilterCriteria] = useState({
    location: "",
    supportType: "",
    postedTime: "",
  });

  const navigate = useNavigate();
  const { jobId } = useParams();
  const baseURL = config.API_BASE_URL;

  const jobType = activeTab;
  const isReduced = selectedJob && window.innerWidth > 480;
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const isSmallMobile = useMediaQuery({ query: "(max-width: 480px)" });
  const [showFilter, setShowFilter] = useState(!isMobile);
  const [likeCounts, setLikeCounts] = useState({});
  const [dislikeCounts, setDislikeCounts] = useState({});

  const jobDetailsRef = useRef(null);

  const truncateString = (str, num) => {
    if (str.length <= num) {
      return str;
    }
    return str.slice(0, num) + "...";
  };

  const getJobTitleDisplay = (job) => {
    const title = getNestedProperty(job, "jobcraftDetails.jobTitle");
    return isReduced ? truncateString(title, 60) : title;
  };

  useEffect(() => {
    fetchAllJobs();
  }, [fetchAllJobs]);

  useEffect(() => {
    if (isMobile && selectedJob) {
      setShowDetails(true);
    } else if (!isMobile) {
      setShowDetails(false);
    }
  }, [isMobile, selectedJob]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768 && selectedJob) {
        setShowDetails(true);
      } else if (window.innerWidth > 768) {
        setShowDetails(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [selectedJob]);

  useEffect(() => {
    if (selectedJob && selectedJob.frequencyDetails) {
      const { scheduling, preferredDays } = selectedJob.frequencyDetails;
      if (scheduling === "Preferred" || scheduling === "Flexible") {
        console.log(`Selected Job Scheduling: ${scheduling}`);
        if (preferredDays) {
          console.log("Selected Job Preferred Days:", preferredDays);
        }
      }
    }
  }, [selectedJob]);

  const location = useLocation();

  useEffect(() => {
    if (
      location.pathname ===
        `/account/ps-dashboard/my-applications/applied-jobs/${jobId}` &&
      jobId
    ) {
      const jobToDisplay = jobs.find((job) => job.id === jobId);
      if (jobToDisplay) {
        setSelectedJob(jobToDisplay);
        setShowDetails(true);
      }
    } else if (
      !location.pathname.includes(`/account/ps-dashboard/applied-jobs`)
    ) {
      setShowDetails(false);
      setSelectedJob(null);
    }
  }, [location, jobId, jobType, jobs]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768 && selectedJob) {
        setShowDetails(true);
      } else if (window.innerWidth > 768) {
        setShowDetails(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [selectedJob]);

  useEffect(() => {
    const filtered = jobs.filter((job) => {
      const matchesSearchQuery =
        searchQuery === "" ||
        job.jobcraftDetails.jobTitle
          .toLowerCase()
          .includes(searchQuery.toLowerCase()) ||
        job.jobcraftDetails.jobDescription
          .toLowerCase()
          .includes(searchQuery.toLowerCase());

      const matchesLocation =
        filterCriteria.location === "" ||
        (job.suburbValue &&
          job.suburbValue
            .toLowerCase()
            .includes(filterCriteria.location.toLowerCase()));

      const matchesSupportType =
        filterCriteria.supportType === "" ||
        job.frequencyDetails.supportType === filterCriteria.supportType;

      const matchesPostedTime =
        filterCriteria.postedTime === "" ||
        new Date(job.postedTime).getTime() >=
          getRelativeTimeInMillis(filterCriteria.postedTime);

      console.log({
        matchesSearchQuery,
        matchesLocation,
        matchesSupportType,
        matchesPostedTime,
      });

      return (
        matchesSearchQuery &&
        matchesLocation &&
        matchesSupportType &&
        matchesPostedTime
      );
    });
    setFilteredJobs(filtered);
    setSelectedJob(null);
    setShowDetails(false);
  }, [searchQuery, filterCriteria, jobs]);

  const handleJobSelect = (job, element) => {
    navigate(`/account/ps-dashboard/my-applications/applied-jobs/${job.id}`, {
      state: { selectedJobId: job.id },
    });
    setSelectedJob(job);
    setShowDetails(true);
    console.log("Selected Job:", job);
    smoothScrollToTop();
    setTimeout(() => {
      const isMobileView = window.innerWidth <= 768;
      if (isMobileView) {
        const mobileContainer = document.querySelector(
          ".mobile-job-items-container"
        );
        if (mobileContainer) {
          const jobElement = mobileContainer.querySelector(
            ".mobile-job-item.selected"
          );
          if (jobElement) {
            const containerRect = mobileContainer.getBoundingClientRect();
            const jobRect = jobElement.getBoundingClientRect();
            const scrollTo =
              jobElement.offsetLeft +
              jobRect.width / 2 -
              containerRect.width / 2;

            mobileContainer.scrollTo({
              left: scrollTo,
              behavior: "smooth",
            });
          }
        }
      } else {
        centerSelectedItem(element, false);
      }
    }, 0);
  };

  const smoothScrollToTop = () => {
    const element = jobDetailsRef.current;
    if (element) {
      const scrollDuration = 600;
      const scrollStep = -element.scrollTop / (scrollDuration / 15);
      const scrollInterval = setInterval(() => {
        if (element.scrollTop !== 0) {
          element.scrollTop += scrollStep;
        } else {
          clearInterval(scrollInterval);
        }
      }, 15);
    }
  };

  const handleBackClick = () => {
    navigate(`/account/ps-dashboard/job-listings/${jobType}`);
    setShowDetails(false);
    setSelectedJob(null);
  };

  const handleLike = (e, job) => {
    e.stopPropagation();
    setLikeCounts((prevCounts) => ({
      ...prevCounts,
      [job.id]: (prevCounts[job.id] || 0) + 1,
    }));
    console.log("Liked job:", job);
  };

  const handleDislike = (e, job) => {
    e.stopPropagation();
    setDislikeCounts((prevCounts) => ({
      ...prevCounts,
      [job.id]: (prevCounts[job.id] || 0) + 1,
    }));
    setDislikeInfo({
      visible: true,
      text: "Reason for disliking the job goes here.",
    });
    console.log("Disliked job:", job);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleFilterChange = (e) => {
    setFilterCriteria({
      ...filterCriteria,
      [e.target.name]: e.target.value,
    });
  };

  const keyDisplayName = {
    "jobcraftDetails.jobTitle": "Job Title",
    "jobcraftDetails.jobDescription": "Job Description",
    postedTime: "Posted Time",
    supportLabels: "Support Type(s)",
    careActivityDetails: "Care Activity Details",
    "supportJobLocationDetails.supportJobLocation": "Support Workplace",
    suburbValue: "Job Location",
    "frequencyDetails.supportType": "Job Frequency",
    "frequencyDetails.sessionsPerWeek": "Sessions Per Week",
    "frequencyDetails.totalHoursPerWeek": "Total Hours Per Week",
    "frequencyDetails.supportStartDate": "Support Starting Date",
    "frequencyDetails.scheduling": "Schedule",
    "frequencyDetails.additionalDetails": "Additional Details",
    "frequencyDetails.preferredDays": "Preferred Days",
    "jobcraftDetails.personalDetails": "Personal Details",
    "supportJobLocationDetails.preferredQualities": "Preferred Qualities",
    "supportJobLocationDetails.preferredGender": "Preferred Gender",
    postedBy: "Posted By",
    clientId: "Client Id",
    id: "Job ID",
  };

  const getNestedProperty = (job, path) => {
    return path.split(".").reduce((acc, part) => acc && acc[part], job);
  };

  const convertTo12HourFormat = (time) => {
    const [hours, minutes] = time.split(":");
    const hour = parseInt(hours, 10);
    const suffix = hour >= 12 ? "PM" : "AM";
    const formattedHour = ((hour + 11) % 12) + 1;
    return `${formattedHour}:${minutes} ${suffix}`;
  };

  const formatPreferredDays = (preferredDays) => {
    const dayEntries = Object.entries(preferredDays);

    const activeDays = dayEntries
      .filter(([_, isPreferred]) => isPreferred)
      .map(([day]) => day);

    if (activeDays.length > 0) {
      console.log("Preferred Days:", activeDays.join(", "));
    } else {
      console.log("No preferred days returned");
    }
  };

  const formatTimeSlots = (timeSlots) => {
    const entries = Object.entries(timeSlots);
    const formattedSlots = entries.reduce((acc, [day, slots]) => {
      if (slots.length > 0) {
        const slotDescriptions = slots.map((slot, index) => {
          const fromTime = convertTo12HourFormat(slot.from);
          const toTime = convertTo12HourFormat(slot.to);
          return `${fromTime} - ${toTime}${
            index < slots.length - 1 ? ", " : ""
          }`;
        });
        acc.push(
          <div key={day}>
            <strong>{day}:</strong> {slotDescriptions}
          </div>
        );
      }
      return acc;
    }, []);

    return formattedSlots.length ? (
      formattedSlots
    ) : (
      <p>No time slots specified.</p>
    );
  };

  const displayOrder = [
    "postedTime",
    "supportLabels",
    "careActivityDetails",
    "jobcraftDetails.jobDescription",
    "frequencyDetails.supportType",
    "suburbValue",
    "supportJobLocationDetails.supportJobLocation",
    "frequencyDetails.sessionsPerWeek",
    "frequencyDetails.totalHoursPerWeek",
    "frequencyDetails.supportStartDate",
    "frequencyDetails.scheduling",
    "frequencyDetails.preferredDays",
    "frequencyDetails.timeSlots",
    "frequencyDetails.additionalDetails",
    "jobcraftDetails.personalDetails",
    "supportJobLocationDetails.preferredQualities",
    "supportJobLocationDetails.preferredGender",
    "postedBy",
  ];

  const pluralize = (count, singular, plural) => {
    return count === 1 ? singular : plural;
  };

  const timeAgo = (postedTime) => {
    const currentTime = new Date();
    const postTime = new Date(postedTime);
    const diffInSeconds = Math.floor((currentTime - postTime) / 1000);

    if (diffInSeconds < 60) {
      return "Posted just now";
    } else if (diffInSeconds < 3600) {
      const minutes = Math.floor(diffInSeconds / 60);
      return `${minutes} ${pluralize(minutes, "minute", "minutes")} `;
    } else if (diffInSeconds < 7200) {
      const hours = Math.floor(diffInSeconds / 3600);
      const minutes = Math.floor((diffInSeconds % 3600) / 60);
      return `${hours} ${pluralize(
        hours,
        "hour",
        "hours"
      )} ${minutes} ${pluralize(minutes, "minute", "minutes")} `;
    } else if (diffInSeconds < 86400) {
      const hours = Math.floor(diffInSeconds / 3600);
      return `${hours} ${pluralize(hours, "hour", "hours")} `;
    } else {
      const days = Math.floor(diffInSeconds / 86400);
      return `${days} ${pluralize(days, "day", "days")} `;
    }
  };

  const getRelativeTimeInMillis = (input) => {
    const now = new Date();
    const [amount, unit] = input.split(" ");
    const value = parseInt(amount, 10);

    switch (unit) {
      case "minute":
      case "minutes":
        return now - value * 60 * 1000;
      case "hour":
      case "hours":
        return now - value * 60 * 60 * 1000;
      case "day":
      case "days":
        return now - value * 24 * 60 * 60 * 1000;
      case "week":
      case "weeks":
        return now - value * 7 * 24 * 60 * 60 * 1000;
      case "month":
      case "months":
        return now - value * 30 * 24 * 60 * 60 * 1000;
      default:
        return now;
    }
  };

  const handleResetFilters = () => {
    setSearchQuery("");
    setFilterCriteria({
      location: "",
      supportType: "",
      postedTime: "",
    });
  };

  const cleanJobDescription = (htmlString) => {
    console.log("Original HTML:", htmlString);

    const cleanedHTML = htmlString.replace(/<p>\s*<br>\s*<\/p>/g, "");

    console.log("Cleaned HTML:", cleanedHTML);

    return cleanedHTML;
  };

  const indexOfLastJob = currentPage * jobsPerPage;
  const indexOfFirstJob = indexOfLastJob - jobsPerPage;
  const currentJobs = filteredJobs.slice(indexOfFirstJob, indexOfLastJob);

  const totalPages = Math.ceil(filteredJobs.length / jobsPerPage);
  const maxPageNumbersToShow = 5;
  const halfPageNumbersToShow = Math.floor(maxPageNumbersToShow / 2);

  const startPage = Math.max(1, currentPage - halfPageNumbersToShow);
  const endPage = Math.min(totalPages, currentPage + halfPageNumbersToShow);

  const pageNumbers = [];
  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  const handlePageChange = (action) => {
    if (action === "previous" && currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    } else if (action === "next" && currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    } else if (typeof action === "number") {
      setCurrentPage(action);
    }
  };

  const toggleFilter = () => {
    setShowFilter(!showFilter);
  };

  const centerSelectedItem = (element, forceMobileScroll) => {
    const scrollContainer = forceMobileScroll
      ? document.querySelector(".mobile-job-items-container")
      : document.querySelector(".job-list");

    if (!scrollContainer) {
      console.error("Scroll container not found.");
      return;
    }

    const elementRect = element.getBoundingClientRect();
    const containerRect = scrollContainer.getBoundingClientRect();

    const scrollTo = forceMobileScroll
      ? element.offsetLeft + elementRect.width / 2 - containerRect.width / 2
      : element.offsetTop + elementRect.height / 2 - containerRect.height / 2;

    scrollContainer.scroll({
      left: forceMobileScroll ? scrollTo : 0,
      top: !forceMobileScroll ? scrollTo : 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="jobs-and-filter-container">
      {isMobile && (
        <div className="filter-toggle-container" onClick={toggleFilter}>
          {showFilter ? (
            <div className="filter-hide">
              <FaTimesCircle />
            </div>
          ) : (
            <div className="filter-show">
              <LuListFilter className="filter-toggle-icon" />
              <span>Show Filters</span>
            </div>
          )}
        </div>
      )}
      {(!isMobile || showFilter) && (
        <div className={`job-search-filter ${isMobile ? "mobile" : ""}`}>
          <input
            type="text"
            placeholder="Filter jobs by title ..."
            value={searchQuery}
            onChange={handleSearchChange}
          />
          <select
            name="location"
            value={filterCriteria.location}
            onChange={handleFilterChange}
          >
            <option value="">All Locations</option>
            {Array.from(new Set(jobs.map((job) => job.suburbValue))).map(
              (location) => (
                <option key={location} value={location}>
                  {location}
                </option>
              )
            )}
          </select>
          <select
            name="supportType"
            value={filterCriteria.supportType}
            onChange={handleFilterChange}
          >
            <option value="">All Support Types</option>
            {Array.from(
              new Set(jobs.map((job) => job.frequencyDetails.supportType))
            ).map((supportType) => (
              <option key={supportType} value={supportType}>
                {supportType}
              </option>
            ))}
          </select>
          <select
            name="postedTime"
            value={filterCriteria.postedTime}
            onChange={handleFilterChange}
          >
            <option value="">Any Time</option>
            <option value="less than an hour ago">Less than an hour ago</option>
            <option value="less than a day ago">Less than a day ago</option>
            <option value="less than a week ago">Less than a week ago</option>
            <option value="less than a month ago">Less than a month ago</option>
          </select>
          <div className="clear-filters-container">
            <button
              className="clear-job-filters-button"
              onClick={handleResetFilters}
            >
              <FaRedo className="job-filter-reset" /> Reset
            </button>
          </div>
        </div>
      )}
      {isMobile && selectedJob && (
        <div className="mobile-job-items-container">
          {filteredJobs.map((job) => (
            <div
              key={job.id}
              className={`mobile-job-item ${
                selectedJob && job.id === selectedJob.id ? "selected" : ""
              }`}
              onClick={(e) => handleJobSelect(job, e.currentTarget)}
            >
              <div className="mobile-job-item-details">
                <h3 className="mobile-job-title">{getJobTitleDisplay(job)}</h3>
                <div className="job-location">
                  <FaMapMarkerAlt className="mobile-job-detail fa-map-marker-alt" />
                  <span>{job.suburbValue}</span>
                </div>
                <div className="job-posted-time">
                  <AiOutlineSchedule className="mobile-job-detail fa-clock" />
                  <span>Posted {timeAgo(job.postedTime)} ago</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      <div className="active-jobs-container">
        <div
          className={`job-list ${selectedJob && !isMobile ? "reduced" : ""} ${
            !showDetails && isMobile ? "show" : ""
          }`}
        >
          {filteredJobs
            .sort(
              (a, b) =>
                new Date(b.postedTime).getTime() -
                new Date(a.postedTime).getTime()
            )
            .map((job) => {
              const currentTime = new Date();
              const postTime = new Date(job.postedTime);
              const diffInSeconds = Math.floor((currentTime - postTime) / 1000);
              const isNew = diffInSeconds < 10800;

              return (
                <div
                  key={job.id}
                  className={`job-item-container ${
                    selectedJob && job.id === selectedJob.id ? "selected" : ""
                  }`}
                >
                  <div
                    id={`job-${job.id}`}
                    className={`job-item ${
                      selectedJob && job.id === selectedJob.id ? "selected" : ""
                    }`}
                    onClick={(e) => handleJobSelect(job, e.currentTarget)}
                  >
                    <h3>{getJobTitleDisplay(job)}</h3>
                    <div className="job-item-content">
                      <div className="job-item-left-right-container">
                        <div className="job-item-left">
                          <span className="job-detail">
                            <FaMapMarkerAlt className="job-detail-icon fa-map-marker-alt" />
                            <strong>Location : </strong>
                            {job.suburbValue}
                          </span>
                          <span className="job-detail">
                            <AiOutlineSchedule className="job-detail-icon fa-clock" />
                            Posted <strong>{timeAgo(job.postedTime)}</strong>{" "}
                            ago
                          </span>
                          <span className="job-detail">
                            <IoIosCheckmarkCircleOutline className="job-detail-icon chckmrk-outline" />
                            <strong>Support Frequency : </strong>
                            {getNestedProperty(
                              job,
                              "frequencyDetails.supportType"
                            )}
                          </span>
                          <div className="apply-early-container">
                            {isNew && (
                              <a href="#" className="apply-early-link">
                                <IoMdTime className="apply-early-icon" />
                                <span className="apply-early-text">
                                  Apply early
                                </span>
                              </a>
                            )}
                          </div>
                        </div>

                        <div className="job-item-separator"></div>

                        <div className="job-item-right">
                          {getNestedProperty(
                            job,
                            "frequencyDetails.sessionsPerWeek"
                          ) > 0 && (
                            <span className="job-detail">
                              <IoIosCheckmarkCircleOutline className="job-detail-icon chckmrk-outline" />
                              <strong>
                                {getNestedProperty(
                                  job,
                                  "frequencyDetails.sessionsPerWeek"
                                )}
                              </strong>{" "}
                              session
                              {getNestedProperty(
                                job,
                                "frequencyDetails.sessionsPerWeek"
                              ) > 1
                                ? "s"
                                : ""}
                              /week
                            </span>
                          )}
                          <span className="job-detail">
                            <IoIosCheckmarkCircleOutline className="job-detail-icon chckmrk-outline" />
                            <strong>
                              {getNestedProperty(
                                job,
                                "frequencyDetails.totalHoursPerWeek"
                              )}
                            </strong>{" "}
                            hour
                            {getNestedProperty(
                              job,
                              "frequencyDetails.totalHoursPerWeek"
                            ) > 1
                              ? "s"
                              : ""}
                            /week
                          </span>
                          <span className="application-count">
                            <FaFire className="application-count-icon" />
                            {job.applicationCount}
                            {job.applicationCount > 15 ? "+" : ""} application
                            {job.applicationCount !== 1 ? "s" : ""}
                          </span>
                        </div>
                      </div>
                      {!isReduced && (
                        <div className="job-item-icons">
                          <div className="likes-container">
                            <FaThumbsUp
                              className="like-icon"
                              onClick={(e) => handleLike(e, job)}
                            />
                            <span className="like-count">
                              {likeCounts[job.id] || 0}
                            </span>
                          </div>
                          <div className="dislikes-container">
                            <FaThumbsDown
                              className="dislike-icon"
                              onClick={(e) => handleDislike(e, job)}
                            />
                            <span className="dislike-count">
                              {dislikeCounts[job.id] || 0}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          {jobs.length > 0 && (
            <div className="active-jobs-pagination">
              <button
                onClick={() => handlePageChange("first")}
                disabled={currentPage === 1}
              >
                &laquo;
              </button>
              <button
                onClick={() => handlePageChange("previous")}
                disabled={currentPage === 1}
              >
                &lt;
              </button>
              <span>
                Page <strong>{currentPage}</strong> of{" "}
                <strong>{totalPages > 99 ? "99+" : totalPages}</strong>
              </span>
              <button
                onClick={() => handlePageChange("next")}
                disabled={currentPage >= totalPages}
              >
                &gt;
              </button>
              <button
                onClick={() => handlePageChange("last")}
                disabled={currentPage >= totalPages}
              >
                &raquo;
              </button>
            </div>
          )}
        </div>
        {selectedJob && (
          <div
            ref={jobDetailsRef}
            className={`job-details ${
              showDetails || window.innerWidth > 480 ? "show" : "hidden"
            }`}
          >
            <div className="job-likes-apply">
              <div className="job-item-icons-big">
                <div className="likes-container">
                  <FaThumbsUp
                    className="like-icon"
                    onClick={(e) => handleLike(e, selectedJob)}
                  />
                  <span className="like-count">
                    {likeCounts[selectedJob.id] || 0}
                  </span>
                </div>
                <div className="dislikes-container">
                  <FaThumbsDown
                    className="dislike-icon"
                    onClick={(e) => handleDislike(e, selectedJob)}
                  />
                  <span className="dislike-count">
                    {dislikeCounts[selectedJob.id] || 0}
                  </span>
                </div>
              </div>
              <button
                className="message-to-apply-btn"
                onClick={() => setShowModal(true)}
              >
                Apply Now
              </button>
            </div>
            <div className="job-detail-content">
              <h2>
                {getNestedProperty(selectedJob, "jobcraftDetails.jobTitle")}
              </h2>
              {displayOrder.map((key) => {
                const detail = getNestedProperty(selectedJob, key);
                if (!detail) return null;
                if (key === "jobcraftDetails.personalDetails") {
                  return (
                    <div key={key}>
                      <h4>Personal Details</h4>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: getNestedProperty(
                            selectedJob,
                            "jobcraftDetails.personalDetails"
                          ),
                        }}
                      ></p>
                    </div>
                  );
                } else if (key === "jobcraftDetails.jobDescription") {
                  return (
                    <div key={key}>
                      <h4>Job Description</h4>
                      <div
                        className="job-details-description"
                        dangerouslySetInnerHTML={{
                          __html: cleanJobDescription(
                            getNestedProperty(
                              selectedJob,
                              "jobcraftDetails.jobDescription"
                            )
                          ),
                        }}
                      ></div>
                    </div>
                  );
                }
                if (key === "frequencyDetails.preferredDays") {
                  if (selectedJob.frequencyDetails.scheduling === "Preferred") {
                    if (
                      selectedJob.frequencyDetails.preferredDays &&
                      Object.values(
                        selectedJob.frequencyDetails.preferredDays
                      ).some(Boolean)
                    ) {
                      return (
                        <div key="preferredDays">
                          <h4>Preferred Days</h4>
                          <p>
                            {formatPreferredDays(
                              selectedJob.frequencyDetails.preferredDays
                            )}
                          </p>
                        </div>
                      );
                    }
                  }
                } else if (
                  key === "frequencyDetails.timeSlots" &&
                  selectedJob.frequencyDetails.scheduling === "Preferred"
                ) {
                  return (
                    <div key={key}>
                      <h4>Preferred Days & Time Slots</h4>
                      {detail && Object.keys(detail).length ? (
                        formatTimeSlots(detail)
                      ) : (
                        <p>No time slots specified.</p>
                      )}
                    </div>
                  );
                }
                if (key === "frequencyDetails.preferredDays") {
                  if (selectedJob.frequencyDetails.scheduling === "Flexible") {
                    if (
                      selectedJob.frequencyDetails.preferredDays &&
                      Object.values(
                        selectedJob.frequencyDetails.preferredDays
                      ).some(Boolean)
                    ) {
                      return (
                        <div key="preferredDays">
                          <h4>Preferred Days</h4>
                          <p>
                            {formatPreferredDays(
                              selectedJob.frequencyDetails.preferredDays
                            )}
                          </p>
                        </div>
                      );
                    }
                  }
                } else if (
                  key === "frequencyDetails.timeSlots" &&
                  selectedJob.frequencyDetails.scheduling === "Flexible"
                ) {
                  return (
                    <div key={key}>
                      <h4>Preferred Days & Time Slots</h4>
                      {detail && Object.keys(detail).length ? (
                        formatTimeSlots(detail)
                      ) : (
                        <p>No time slots specified.</p>
                      )}
                    </div>
                  );
                } else {
                  return (
                    <div key={key}>
                      <h4>{keyDisplayName[key] || key}</h4>
                      <p>
                        {Array.isArray(detail) ? detail.join(", ") : detail}
                      </p>
                    </div>
                  );
                }
              })}
            </div>
            <button className="back-button" onClick={handleBackClick}>
              <span className="back-arrow">←</span> Back to Job list
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default DiscoverJobList;
